import React from 'react';

import { ICategory } from '@Hotels-at-Home/hah-fe-core/dist/types/category';
import CategoryBackground from './CategoryBackground';
import BannerWrapper from '@Hotels-at-Home/hah-fe-core/dist/components/BannerWrapper';
import { useSelector } from '~/store/hooks';
import selectPromotion from '~/storeSelectors/promotion';
import { useWindowSize } from '@Hotels-at-Home/hah-fe-core/dist/hooks';
import { SM_WIDTH } from '@Hotels-at-Home/hah-fe-core/dist/constants';

interface IProps {
  category: ICategory;
}
const CategoryHeader = ({ category }: IProps) => {
  const { width } = useWindowSize();
  const isMobile = Boolean(width) && width <= SM_WIDTH;
  const promotion = useSelector(selectPromotion);

  return (
    <>
      {isMobile && <BannerWrapper promotion={promotion} />}
      <div id="category-header" className="item ctg-header">
        <div className="name-wrapper">
          <h1 className="name font-main-heading-1">
            <span>{category.name}</span>
          </h1>
        </div>
        <CategoryBackground categoryName={category.name_en.category_name} />
      </div>
      {!isMobile && <BannerWrapper promotion={promotion} />}
    </>
  );
};

export default CategoryHeader;
